export  default {
    getDeviceStatuses(state) {
        return state.deviceStatuses;
    },
    getCurrentDeviceStatus(state) {
        return state.currentDeviceStatus;
    },
};